import { createContext, useContext, useEffect, useState } from "react";
import { findMembershipPlanByName, membershipPlans } from "../data/membershipPlans";

const CartContext = createContext();

const VALID_MEMBERSHIP_NAMES = membershipPlans.map((plan) => plan.name);

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState([]);
  const [membership, setMembership] = useState(null);

  useEffect(() => {
    const savedCart = JSON.parse(localStorage.getItem("mistribazaarCart")) || [];
    const savedMembership =
      JSON.parse(localStorage.getItem("mistribazaarMembership")) || null;

    setCartItems(Array.isArray(savedCart) ? savedCart : []);

    if (
      savedMembership &&
      VALID_MEMBERSHIP_NAMES.includes(savedMembership.name)
    ) {
      setMembership(findMembershipPlanByName(savedMembership.name) || savedMembership);
    } else {
      setMembership(null);
      localStorage.removeItem("mistribazaarMembership");
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("mistribazaarCart", JSON.stringify(cartItems));
  }, [cartItems]);

  useEffect(() => {
    if (membership) {
      localStorage.setItem(
        "mistribazaarMembership",
        JSON.stringify(membership)
      );
    } else {
      localStorage.removeItem("mistribazaarMembership");
    }
  }, [membership]);

  const addToCart = (item) => {
    setCartItems((prev) => [...prev, item]);
  };

  const removeFromCart = (index) => {
    setCartItems((prev) => prev.filter((_, i) => i !== index));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const clearMembership = () => {
    setMembership(null);
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        clearCart,
        membership,
        setMembership,
        clearMembership,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
